import React from "react";
import { ANNOUNCEMENTS } from "../mock";

const AnnouncementBar = () => {
  return (
    <div className="overflow-hidden border-b relative z-40" style={{ backgroundColor: "#E4B8B8", borderColor: "rgba(26,26,26,0.15)" }}>
      <div className="flex whitespace-nowrap ticker-track py-2">
        {[...ANNOUNCEMENTS, ...ANNOUNCEMENTS, ...ANNOUNCEMENTS].map((a, i) => (
          <div key={i} className="flex items-center shrink-0 px-8">
            <span className="font-mono text-[11px] tracking-[0.2em] uppercase font-medium text-off-white">{a}</span>
            <span className="mx-8 text-off-white/40">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
